import React from 'react';
import { css, Theme } from '@emotion/react';
import styled from '@emotion/styled';
import { ContentKeys } from '~/styles/themes';
import { FontStyleDeepKeys } from '~/styles/themes/fontStyle';

interface TextProps {
  children: React.ReactNode | string;
  as?: React.ElementType;
  fontStyle: FontStyleDeepKeys;
  color?: ContentKeys;
}

export default function Text({
  children,
  as = 'div',
  fontStyle,
  color,
  ...props
}: TextProps) {
  return (
    <TextComponent as={as} color={color} fontStyle={fontStyle} {...props}>
      {children}
    </TextComponent>
  );
}

function getNestedStyle(theme: any, fontStyle: FontStyleDeepKeys): string {
  return fontStyle
    .split('.')
    .reduce((style, key) => style[key], theme.fontStyle);
}

const TextComponent = styled('div')<{
  fontStyle: FontStyleDeepKeys;
  color?: ContentKeys;
}>`
  ${({ theme, color, fontStyle }) => css`
    display: block;
    ${getNestedStyle(theme, fontStyle)};
    color: ${color ? theme.content[color] : 'inherit'};
  `};
`;
